import commonHelper from '@/app/utility/common.helper.utility';
import URL_UTILITY from '../../../../../utility/url.utility';
import previewDoc from '../../../../onlineApproval/internalWorkFlow/history/uploadDocument/previewDoc';
export default {
  name: 'Additional',
  components: { previewDoc },
  props: [
    'partyRowDetails',
    'urlSummaryData',
    'workflowId',
    'dashboardDetails'
  ],
  data() {
    return {
      loader: false,
      isSuccess: false,
      showAlert: false,
      responseMsg: '',
      additionalData: [],
      additionalFields: [
        {
          key: 'original_file_name',
          label: 'File Name'
        },
        {
          key: 'file_name',
          label: 'Preview'
        },
        {
          key: 'add_info_desc_meaning',
          label: 'Additional Info'
        },
        {
          key: 'is_applicable'
        },
        {
          key: 'additional_info_val',
          label: 'Additional Value'
        },
        {
          key: 'certificate_no'
        }
      ],
      partyReqId: null,
      wfDtlId: null,
      eventId: null,
      approvalStatus: null,
      uploadedFileName: null,
      showOpenModal: false,
      docDtlId: null,
      authToken: null,
      openKmAuth: null,
      downloadDocUrl: URL_UTILITY.getOpenKmDocDeleteUrl,
      dynamicData:null,
      currentPageIndex:null,
      accessButtons: {
        deleteAllow: false,
        downloadAllow: false,
        uploadAllow: false,
        editAllow: false,
        addAllow: false,
        printAllow: false,
        approvalAllow: false,
        newTab: true,
      },
      clientModal: false,
      clientData: [],
      clientFields: [
        {
          key: 'attribute1',
          label: 'Name of Organisation'
        },
        {
          key: 'attribute2',
          label: 'Address'
        },
        {
          key: 'attribute3',
          label: 'Phone No.'
        },
        {
          key: 'attribute4',
          label: 'Contact Person With Designation'
        },
        {
          key: 'attribute5',
          label: 'Items Supplied'
        },
      ],
      materialSourceModal: false,
      materialData: [
        {
          add_info_dtls_id: null,
          attribute1: null,
          attribute2: null,
          attribute3: null
        }
      ],
      materialFields: [
        {
          key: 'attribute1',
          label: 'Products'
        },
        {
          key: 'attribute2',
          label: 'Specification'
        },
        {
          key: 'attribute3',
          label: 'Source'
        }
      ],
      materialTypeModal: false,
      materialTypeData: [
        {
          add_info_dtls_id: null,
          attribute1: null,
          attribute2: null,
          attribute3: null,
          attribute4: null,
          attribute5: null
        }
      ],
      materialTypeFields: [
        {
          key: 'attribute1',
          label: 'Material Type'
        },
        {
          key: 'attribute2',
          label: 'Item Name'
        },
        {
          key: 'attribute3',
          label: 'Std Packing Qty'
        },
        {
          key: 'attribute4',
          label: 'Min. Order Qty'
        },
        {
          key: 'attribute5',
          label: 'Capacity'
        }
      ],
      einvoiceModalFlag:false,
      einvoiceNum:null,
      einvoiceType:null,
      einvoiceStatus:null,
      validateButtnName:'Verify',
      einvoiceId:0,
      einvoiceGstin:null,
    };
  },
  mounted() {
    if (this.partyRowDetails) {
      this.partyReqId = this.partyRowDetails.req_id;
      this.wfDtlId = this.partyRowDetails.inprocess_dtl_id;
      this.eventId = this.workflowId.eventId;
    }
    if (this.urlSummaryData) {
      this.partyReqId = this.urlSummaryData.PARTY_REQ_ID;
      this.wfDtlId = this.urlSummaryData.wf_inprocess_dtl_id;
      this.eventId = this.urlSummaryData.wf_event_id;
    }
    if (this.dashboardDetails) {
      this.partyReqId = this.dashboardDetails.party_req_id;
    }
    this.getAdditionalDetails();
  },
  methods: {
    getAdditionalDetails() {
      const payload = {
        party_req_id: this.partyReqId
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getAdditionalDetails', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            this.additionalData = resp.data.data;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    openPreviewDoc(flag, docDtlId, fileName, index, data) {
      const filterDynamicData = data.filter((a) => a.original_file_name);
      const getFileName = data[index].original_file_name;
      for (let i = 0; i < filterDynamicData.length; i++) {
        if (filterDynamicData[i].original_file_name == getFileName) {
          this.currentPageIndex = i + 1;
          break;
        }
      }
      this.dynamicData = filterDynamicData;
      if (flag) {
        this.getOpenKmAuthTokenPreview(flag, docDtlId, fileName);
        // this.timeout = setTimeout(() => {
        //   // this.showHideOpenModal(flag, docDtlId, this.openKmAuth, fileName);   previous function
        //   this.partOnboardingPreview(flag, docDtlId, this.openKmAuth, fileName);
        // }, 1000);
      }
    },
    partOnboardingPreview(flag, docDtlId, authToken, fileName){
      if (flag) {
        this.fileExtension = commonHelper.getFileExtension(fileName);
      }
      if (this.fileExtension === 'xlsx') {
        alert('Not Allowed');
      } else {
        // this.showOpenModal = flag;
        this.docDtlId = docDtlId;
        this.authToken = authToken;
        this.uploadedFileName = fileName;
        this.previewOpenDoc();        
      } 
    },
    previewOpenDoc() {
      this.fileExtension = commonHelper.getFileExtension(this.uploadedFileName);
      const payload = {
        docDetailId: this.docDtlId,
        token: this.authToken,
        fileExtension: this.fileExtension
      };
      this.loader = true;
      commonHelper.previewImgDocParty(payload);
       this.loader =false;
    },
    showHideOpenModal(flag, docDtlId, authToken, fileName) {
      if (flag) {
        this.fileExtension = commonHelper.getFileExtension(fileName);
      }
      if (this.fileExtension === 'xlsx') {
        alert('Not Allowed');
      } else {
        this.showOpenModal = flag;
        this.docDtlId = docDtlId;
        this.authToken = authToken;
        this.uploadedFileName = fileName;
      }
    },
    getOpenKmAuthTokenPreview(flag, docDtlId, fileName) {
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/openKmPartyPortalAuthenticate')
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.openKmAuth = response.data.data.token;
            if(this.openKmAuth){
              // this.partOnboardingPreview(flag, docDtlId, this.openKmAuth, fileName);
              this.showHideOpenModal(flag, docDtlId, this.openKmAuth, fileName);
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getOpenKmAuthToken(docDtlId, fileName) {
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/openKmPartyPortalAuthenticate')
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.openKmAuth = response.data.data.token;
            const url =
              this.downloadDocUrl +
              '/download/' +
              docDtlId +
              '?token=' +
              this.openKmAuth;
            commonHelper.downloadFile(url, fileName);
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    openClientDetails(flag, index) {
      this.clientModal = flag;
      this.addInfoIdCreated = index;
      if(flag){
      this.getClientDetailsById();
      }
    },
    openMaterialSourceDetails(flag, index) {
      this.materialSourceModal = flag;
      this.addInfoIdCreated = index;
      if(flag){
      this.getMaterialDetailsById();
    }
    //  else {
    //     this.editMode = true;
    // }
    },
    openMaterialTypeDetails(flag, index) {
      this.materialTypeModal = flag;
      this.addInfoIdCreated = index;
      if(flag){
      this.getMaterialTypeDetailsById();
    }
    },
    getMaterialDetailsById() {
      this.materialData = [];
      const payload = {
        partyReqId: this.partyReqId,
        vsetType: 'Raw Material'
      };
      this.loader = true;
      this.$store
        .dispatch("intWorkflow/getDetailsById", payload)
        .then((resp) => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data;
            this.materialData = result;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },getMaterialTypeDetailsById() {
      this.materialTypeData = [];
      const payload = {
        partyReqId: this.partyReqId,
        vsetType: 'Material Type'
      };
      this.loader = true;
      this.$store
        .dispatch("intWorkflow/getDetailsById", payload)
        .then((resp) => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data;
            this.materialTypeData = result;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getClientDetailsById() {
      this.clientData = [];
      const payload = {
        partyReqId: this.partyReqId,
        vsetType: 'Client'
      };
      this.loader = true;
      this.$store
        .dispatch("intWorkflow/getDetailsById", payload)
        .then((resp) => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data;
            this.clientData = result;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    openEinvoiceModal(flag){
      this.einvoiceModalFlag=flag;
      if(flag){
        this.accessButtons= {
          deleteAllow: false,
          downloadAllow: false,
          uploadAllow: false,
          editAllow: false,
          addAllow: false,
          printAllow: false,
          approvalAllow: false,
          newTab: false
        }
        this.getEinvoiceDetails()
      }
      // else{
      //   this.einvoiceNum=null
      // }
    },
    getEinvoiceDetails(){
      const payload = {
        party_req_id:this.partyReqId,
       };
       this.loader = true;
       this.$store
         .dispatch("intWorkflow/getEinvoiceDetails", payload)
         .then((response) => {
           this.loader = false;
           if (response.status == 200) {
             this.showAlert = false;
             this.isSuccess = true;
              if(response.data.data){
             const einvoiceData= JSON.parse(response.data.data.einvoice_json)
             this.einvoiceType=einvoiceData.data.type;
             this.einvoiceStatus=einvoiceData.data.status;
             this.responseMsg= response.data.message;
             this.einvoiceId=response.data.data.einvoice_ver_id;
             this.einvoiceGstin=einvoiceData.data.gstin;
             }
           } else {
             this.showAlert = true;
             this.isSuccess = false;
             this.responseMsg = response.data.message;
           }
         })
         .catch(() => {
           this.loader = false;
           this.showAlert= true;
           this.isSuccess = false;
         });
   },
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  }
};
